export const press = [
    {
        "title": "Poems at Every Point of the Supply Chain: kathy wu with basalt hsu",
        "publication": "Poetry Project",
        "url": "https://www.poetryproject.org/publications/newsletter/285-summer-2026/poems-at-every-point-of-the-supply-chain-an-interview-with-kathy-wu?page=1",
        "year": "2026"
    },
    {
        "title": "Stones as Promise, as Poetry",
        "publication": "Lullaby Machine",
        "url": "https://lullabymachine.com/essays/stones-as-promise",
        "year": "2026"
    },
    {
        "title": "Feature: She Will Last as Long as Stones",
        "publication": "Cleveland Review of Books",
        "url": "https://clereviewofbooks.com/from-she-will-last-as-long-as-stones/",
        "year": "2026"
    },
    {
        "title": "kathy wu discusses their debut book SHE WILL LAST AS LONG AS STONES",
        "publication": "Interlocutor Magazine",
        "url": "https://interlocutorinterviews.com/new-blog/2026/2/25/kathy-wu-interview-she-will-last-as-long-as-stones-wendys-subway",
        "year": "2026"
    },
    {
        "title": "What is a Cloud? Reflections on kathy wu's INTO UNCERTAIN WEATHERS",
        "publication": "CultureHub",
        "url": "https://www.culturehub.org/read/what-is-a-cloud",
        "year": "2025"
    },
    {
        "title": "Diana Khoi Nguyen, Quyên Nguyễn-Hoàng, Monica Ong, and Sasha Stiles by Jason N. Le",
        "publication": "BOMB Magazine",
        "url": "https://bombmagazine.org/articles/2024/07/16/diana-khoi-nguyen-quy%C3%AAn-nguy%E1%BB%85n-ho%C3%A0ng-monica-ong-and-sasha-stiles-by-jason-n-le/",
        "year": "2024"
    }
] as const